/* Galeri lightbox: buyutulmus gorsel + ileri/geri + tiklayarak yakinlastirma.
   Kaynak listeyi galerideki slaytlardan okur, kendi veri kopyasini tutmaz —
   varyant degisince slayt src'si degistiginde lightbox da guncel kalir. */
(function () {
  "use strict";

  var box = document.querySelector("[data-lightbox]");
  if (!box) return;

  var img = box.querySelector("[data-lightbox-image]");
  var counter = box.querySelector("[data-lightbox-counter]");
  var index = 0;

  function items() {
    /* Sadece gorsel slaytlar: video slaytlari div, data-zoom-src'leri yok. */
    return Array.prototype.slice.call(
      document.querySelectorAll(".product-gallery__slide[data-zoom-src]")
    );
  }

  function show(i) {
    var list = items();
    if (!list.length) return;
    index = (i + list.length) % list.length;
    var el = list[index];
    img.src = el.getAttribute("data-zoom-src");
    img.alt = el.getAttribute("alt") || "";
    img.classList.remove("is-zoomed");
    img.style.transformOrigin = "center center";
    if (counter) counter.textContent = index + 1 + " / " + list.length;
  }

  function open() {
    var list = items();
    var active = document.querySelector(".product-gallery__slide.is-active");
    var start = active ? list.indexOf(active) : 0;
    box.hidden = false;
    /* hidden kalkar kalkmaz sinif eklenirse gecis oynamiyor; arka plan
       sekmesinde rAF hic calismadigi icin zorunlu reflow kullaniliyor. */
    void box.offsetHeight;
    box.classList.add("is-open");
    document.body.classList.add("nav-locked");
    show(start < 0 ? 0 : start);
  }

  function close() {
    if (box.hidden) return;
    box.classList.remove("is-open");
    document.body.classList.remove("nav-locked");
    window.setTimeout(function () { box.hidden = true; img.removeAttribute("src"); }, 200);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-lightbox-open]")) { e.preventDefault(); open(); return; }
    if (e.target.closest("[data-lightbox-close]")) { close(); return; }
    if (e.target.closest("[data-lightbox-prev]")) { show(index - 1); return; }
    if (e.target.closest("[data-lightbox-next]")) { show(index + 1); return; }
    /* Bos alana tiklayinca kapansin; gorselin kendisi yakinlastirma yapar. */
    if (e.target === box) close();
  });

  img.addEventListener("click", function (e) {
    var zoomed = img.classList.toggle("is-zoomed");
    if (!zoomed) { img.style.transformOrigin = "center center"; return; }
    var r = img.getBoundingClientRect();
    var x = ((e.clientX - r.left) / r.width) * 100;
    var y = ((e.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = x + "% " + y + "%";
  });

  document.addEventListener("keydown", function (e) {
    if (box.hidden) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") show(index - 1);
    if (e.key === "ArrowRight") show(index + 1);
  });
})();
